<template>
  <component
    :is="playerComponent"
    :preload="true"
    :autoplay="status === 1"
    :source="sourceUrl"
    :cover="coverUrl"
    ref="video"
    class="video"
    :skinLayout="skinLayout"
    :height="videoHeight"
    :video-height="videoHeight"
    @canplaythrough="canplaythroughimp"
    @pause="pause"
    @play="play"
    @ended="ended"
    @error="onError"
  />
</template>

<script>
import AliyunPlayer from './AliyunPlayer'

export default {
  name: 'VideoPlayer',
  components: {
    AliyunPlayer,
    HlsPlayer: () => import('./HlsPlayer')
  },
  props: {
    playInfo: Object,
    videoHeight: String,
    coverUrl: String,
    // 播放状态：1-播放 0-暂停
    status: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      progressToSeek: 0,
      seekTimer: null,
      seekAttempts: 0,
      skinLayout: [
        {
          name: 'bigPlayButton',
          align: 'cc'
        },
        {
          name: 'H5Loading',
          align: 'cc'
        },
        {
          name: 'errorDisplay',
          align: 'tlabs',
          x: 0,
          y: 0
        },
        {
          name: 'controlBar',
          align: 'blabs',
          x: 0,
          y: 0,
          children: [
            {
              name: 'progress',
              align: 'blabs',
              x: 0,
              y: 44
            },
            {
              name: 'playButton',
              align: 'tl',
              x: 15,
              y: 12
            },
            {
              name: 'timeDisplay',
              align: 'tl',
              x: 10,
              y: 7
            },
            { name: 'setting', align: 'tr', x: 15, y: 12 },
            { name: 'volume', align: 'tr', x: 5, y: 10 },
            {
              name: 'fullScreenButton',
              align: 'tr',
              x: 10,
              y: 12
            }
          ]
        }
      ]
    }
  },
  computed: {
    playerComponent() {
      return /\.m3u8(?:[?#]|$)/i.test(this.sourceUrl) ? 'HlsPlayer' : 'AliyunPlayer'
    },
    sourceUrl() {
      return (this.playInfo && this.playInfo.playURL) || ''
    },
    player: {
      cache: false,
      get() {
        return this.$refs.video
      }
    }
  },
  watch: {
    status(value, old) {
      if (value === 1) {
        this.setPlay()
      } else if (value === 0) {
        this.setPause()
      }
    },
    playInfo: {
      immediate: true,
      handler(value, old) {
        this.clearSeekTimer()
        this.seekAttempts = 0
        const progress = Number(value && value.progress)
        this.progressToSeek = Number.isFinite(progress) && progress > 0 ? progress : 0
        // A new lesson can reuse the same URL; restart it even without a source change.
        if (value && old && value.playURL === old.playURL) {
          this.$nextTick(() => {
            if (this.$refs.video) this.$refs.video.reloadPlayer()
          })
        }
      }
    }
  },
  beforeDestroy() {
    this.clearSeekTimer()
  },
  methods: {
    clearSeekTimer() {
      clearTimeout(this.seekTimer)
      this.seekTimer = null
    },
    onError(event) {
      const detail = (event && event.paramData) || event || {}
      console.error('Video playback failed: ' + JSON.stringify({
        code: detail.error_code || detail.code || detail.Code,
        message: detail.error_msg || detail.message || detail.Message
      }))
      this.$emit('error', event)
    },
    setPause() {
      const player = this.$refs.video
      player && player.pause()
    },
    setPlay() {
      const player = this.$refs.video
      player && player.play()
    },
    pause() {
      this.$emit('pause')
    },
    play() {
      this.$emit('play')
    },
    ended() {
      this.$emit('ended')
    },
    canplaythroughimp() {
      const player = this.$refs.video
      if (!player || this.seekTimer !== null || this.progressToSeek <= 0) return
      const duration = player.getDuration()
      if (!duration) return
      if (this.progressToSeek >= duration || this.seekAttempts >= 3) {
        this.progressToSeek = 0
        return
      }
      this.seekAttempts++
      this.seekTimer = setTimeout(() => {
        this.seekTimer = null
        if (!this.$refs.video) return
        if (this.$refs.video.getCurrentTime() >= this.progressToSeek - 1) {
          this.progressToSeek = 0
        } else {
          this.canplaythroughimp()
        }
      }, 500)
      player.seek(this.progressToSeek)
    }
  }
}
</script>

<style scoped></style>
